/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'currency-pound': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" _stroke="#111827" _fill="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
